const socialMedia = ['Facebook', 'YouTube', 'LinkedIn', 'Instagram', 'Twitter']
const loggedUsersRequiredFields = ['interested', 'contactOptions', 'questions', 'aceptTerms', 'jobFunction']
const nonLoggedUsersRequiredFields = [
  'name',
  'lastName',
  'email',
  'phone',
  'country',
  'organization',
  ...loggedUsersRequiredFields
]

export function validate(values) {
  let errors = {}
  let requiredFields

  if (values.stullerAccount) {
    requiredFields = loggedUsersRequiredFields
  } else {
    requiredFields = nonLoggedUsersRequiredFields
  }

  requiredFields.forEach((field) => {
    if (
      (field === 'interested' && values.interested === 'other' && !values['textArea-interested']) ||
      values['textArea-interested']?.toString().trim() === ''
    ) {
      errors['textArea-interested'] = 'Required'
    }
    if (field === 'country' && values.country === 'us' && !values.state) {
      errors.state = 'Required'
    }
    if (
      (field === 'jobFunction' && values.jobFunction === 'other' && !values['textArea-jobFunction']) ||
      values['textArea-jobFunction']?.toString().trim() === ''
    ) {
      errors['textArea-jobFunction'] = 'Required'
    }
    if (field === 'questions' && values.questions === 'Social media') {
      if (!socialMedia.find((socialMedia) => values[socialMedia])) {
        errors['socialMedia'] = 'Required'
      }
    }
    if (
      (field === 'questions' && values.questions === 'Other' && !values['textArea-other']) ||
      values['textArea-other']?.toString().trim() === ''
    ) {
      errors['textArea-other'] = 'Required'
    }
    if (!values[field] || values[field]?.toString().trim() === '') {
      errors[field] = 'Required'
    }
  })

  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  return errors
}
